<iframe [src]="messagingURL | safe:'resourceUrl'" #messagingApp frameborder="0"></iframe>